import gql from 'graphql-tag'
const q = gql`
    query VimeoOauthEndpoint ($id:ID!) {
      VimeoOauthEndpoint (id: $id) {
        url
      }
    }
  `
export default q
